import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p458092349744021504',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
